// DS: DS9.7
import React from 'react';
import c from 'classnames';
import Button from '../Buttons/GhostButton';
import s from './EmptyState.scss';
var EmptyState = function (_a) {
    var className = _a.className, titleClassName = _a.titleClassName, subtitleClassName = _a.subtitleClassName, withIllustrationBelow = _a.withIllustrationBelow, title = _a.title, subtitle = _a.subtitle, illustration = _a.illustration, withButton = _a.withButton, buttonLabel = _a.buttonLabel, customButton = _a.customButton, customSecondaryButton = _a.customSecondaryButton, onButtonClick = _a.onButtonClick, biData = _a.biData;
    return (React.createElement("div", { className: c(s['root'], className) },
        illustration && (React.createElement("div", { className: c(s['illustration'], withIllustrationBelow && s['illustration-below']) }, illustration)),
        React.createElement("div", { className: c(s['title'], titleClassName) }, title),
        React.createElement("div", { className: c(s['subtitle'], subtitleClassName) }, subtitle),
        React.createElement("div", { className: s['buttons'] },
            customSecondaryButton,
            customButton ||
                (withButton && (React.createElement(Button, { variant: "main", size: "medium", onClick: onButtonClick, biData: biData }, buttonLabel))))));
};
EmptyState.displayName = 'EmptyState';
export default EmptyState;
//# sourceMappingURL=EmptyState.js.map